import { get, post } from '../axios'

const api = `${process.env.VUE_APP_COMMON}`

// 查询赛马开关
export function nav_race_query(map, option) {
  return get(`${api}/nav/race/switch/query`, map, option)
}
// 保存赛马开关
export function nav_race_save(map, option) {
  return post(`${api}/nav/race/switch/save`, map, option)
}
